(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["c-fullprotein-media-blocks"] && !Shopify.designMode) return;
  try {
    
/* テーマ標準の DialogElement（assets/theme.js）の最小 fork。
   開閉トグル・フォーカストラップ・ESC・aria-expanded 同期は基底クラスがすでに持っている。
   ここでは背面スクロールロック、body 直下への退避、背景クリックで閉じる処理だけを足す。

   theme.js は type="module" で読み込まれるため、この時点では未定義の可能性がある。 */
customElements.whenDefined('dialog-element').then(() => {
  if (customElements.get('fullprotein-modal')) return;

  class FullproteinModal extends customElements.get('dialog-element') {
    constructor() {
      super();

      /* 基底クラスの外側クリック判定は「カスタム要素の外側」を見るが、
         この要素は全画面を覆うので背景クリックも「内側」になる。自前で閉じる。
         shouldAppendToBody による body への移動で connectedCallback は再実行されるため、
         リスナーは 1 度しか通らない constructor で張る。 */
      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-fp-modal-close]') || !event.target.closest('.c-fullprotein-modal__panel')) {
          this.hide();
        }
      });
    }

    get shouldLock() {
      return true;
    }

    /* 祖先の overflow / stacking context を脱出する */
    get shouldAppendToBody() {
      return true;
    }

    get initialFocus() {
      return this.querySelector('[data-fp-modal-close]');
    }
  }

  customElements.define('fullprotein-modal', FullproteinModal);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-review-slider"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var SWIPER_CSS = "https://cdn.jsdelivr.net/npm/swiper@8/swiper-bundle.min.css";
    var SWIPER_JS = "https://cdn.jsdelivr.net/npm/swiper@8/swiper-bundle.min.js";
    var loadingPromise = null;

    function loadSwiper() {
      if (window.Swiper) 
        returnPromise.resolve();
      


      if (loadingPromise) return loadingPromise;
      


      loadingPromise = new Promise(function(resolve, reject) {
        var link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = SWIPER_CSS;
        document.head.appendChild(link);

        var script = document.createElement("script");
        script.src = SWIPER_JS;
        script.onload = resolve;
        script.onerror = reject;
        document.body.appendChild(script);
      });
      return loadingPromise;
    }

    function initOne(root) {
      if (root.dataset.rsInit) return;
      


      root.dataset.rsInit = "1";

      var swiperEl = root.querySelector(".c-review-slider__swiper");
      if (! swiperEl) return;
      


      var autoplayOn = root.dataset.autoplay === "true";
      var delay = (parseFloat(root.dataset.autoplayDelay) || 4) * 1000;

      var options = {
        slidesPerView: "auto",
        spaceBetween: 12,
        centeredSlides: false,
        grabCursor: true,
        loop: autoplayOn,
        slidesOffsetBefore: 24,
        slidesOffsetAfter: 24,
        breakpoints: {
          768: {
            slidesOffsetBefore: 20,
            slidesOffsetAfter: 20
          }
        },
        pagination: {
          el: root.querySelector(".c-review-slider__pagination"),
          clickable: true
        }
      };

      if (autoplayOn) {
        options.autoplay = {
          delay: delay,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        };
      }

      var swiper = new Swiper(swiperEl, options);

      var prev = root.querySelector(".c-review-slider__nav-prev");
      var next = root.querySelector(".c-review-slider__nav-next");
      if (prev) 
        prev.addEventListener("click", function() {
          swiper.slidePrev();
        });
      


      if (next) 
        next.addEventListener("click", function() {
          if (swiper.isEnd) {
            swiper.slideTo(0);
          } else {
            swiper.slideNext();
          }
        });
      


    }

    function init(scope) {
      var roots = (scope || document).querySelectorAll(".c-review-slider");
      if (! roots.length) return;
      


      loadSwiper().then(function() {
        roots.forEach(initOne);
      }).catch(function() {});
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", function() {
        init();
      });
    } else {
      init();
    }

    document.addEventListener("shopify:section:load", function(e) {
      init(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-yappy-chat-bubble"] && !Shopify.designMode) return;
  try {
    
(function () {
  function reveal(el) {
    if (el.dataset.ycbInit) return;
    el.dataset.ycbInit = "1";

    if (!("IntersectionObserver" in window)) {
      el.classList.add("is-visible");
      return;
    }

    var observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.4 }
    );
    observer.observe(el);
  }

  function init(root) {
    (root || document).querySelectorAll(".c-yappy-chat-bubble").forEach(reveal);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { init(); });
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-yappy-video-slider"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSlider(slider) {
    if (slider.dataset.yvsInit) return;
    slider.dataset.yvsInit = '1';

    var track = slider.querySelector('.c-yappy-video-slider__track');
    var btnPrev = slider.querySelector('.c-yappy-video-slider__arrow--prev');
    var btnNext = slider.querySelector('.c-yappy-video-slider__arrow--next');
    if (!track || !btnNext) return;

    function getGap() {
      return parseInt(getComputedStyle(track).columnGap, 10) || 0;
    }

    function getScrollAmount() {
      var item = track.querySelector('.c-yappy-video-slider__item');
      return item ? item.offsetWidth + getGap() : track.clientWidth * 0.8;
    }

    function updateArrows() {
      var scrollLeft = Math.round(track.scrollLeft);
      var maxScroll = Math.round(track.scrollWidth - track.clientWidth);

      if (btnPrev) {
        if (scrollLeft > 4) {
          btnPrev.removeAttribute('hidden');
        } else {
          btnPrev.setAttribute('hidden', '');
        }
      }

      if (scrollLeft >= maxScroll - 4) {
        btnNext.setAttribute('hidden', '');
      } else {
        btnNext.removeAttribute('hidden');
      }
    }

    btnNext.addEventListener('click', function () {
      track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
    });

    if (btnPrev) {
      btnPrev.addEventListener('click', function () {
        track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
      });
    }

    track.addEventListener('scroll', updateArrows, { passive: true });
    updateArrows();
  }

  function init(root) {
    (root || document)
      .querySelectorAll('.c-yappy-video-slider--slider')
      .forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
